import { IGalleryCounterProps } from '../gallery';

import * as styles from './MultiAdsGalleryCounter.css';

export function MultiAdsGalleryCounter(props: IGalleryCounterProps) {
  const { currentIndex, itemsTotal } = props;

  return <div className={styles['counter']}>{`${currentIndex + 1}/${itemsTotal}`}</div>;
}
